export const shouldDisplaySavings = (amount: string) => {
  if (!amount) return false;
  return currencyToFloat(amount) !== 0 && !isNaN(currencyToFloat(amount));
};

const currencyToFloat = (currency: string) => {
  // remove any characters that are not digits (0-9), hyphens (-), or periods (.)
  const currencyConvertedToNumber = currency.replace(/[^0-9.-]/g, '');
  return parseFloat(currencyConvertedToNumber);
};
